/* eslint-disable max-len */
import React, { useCallback, useState } from 'react';
import { PlateLine } from '@1po/1po-bff-fe-spec/generated/catalog/easy_basket/response/GetEasyBasketOperationDetailResponse';
import styled from 'styled-components';
import Plate from 'pages/CatalogPage/DH/SubcategorySection/OperationsSection/PartsSelection/PlateModal/Plate';
import { Box, Modal } from 'UI';

interface PlateModalProps {
  plateLines: PlateLine[];
  triggerComponent: React.ReactNode;
}

const SModal = styled(Modal)`
  .ant-modal-body {
    padding: 0 0 30px 0;
  }
`;

const PlateModal = ({ triggerComponent, plateLines }: PlateModalProps) => {
  const [showModal, setShowModal] = useState(false);
  const handleChangeShowModal = () => {
    setShowModal((prev) => !prev);
  };
  const [selectedPlateLine, setSelectedPlateLine] = useState<PlateLine>(plateLines[0]);

  const handleSelectPlateLine = useCallback(
    (plateIds: string[]) => {
      const id = plateIds[0];
      const plateLine = plateLines?.find((p) => p.plate.id === id);
      if (plateLine) {
        setSelectedPlateLine(plateLine);
      }
    },
    [plateLines],
  );

  return (
    <>
      <Box onClick={handleChangeShowModal}>{triggerComponent}</Box>
      <SModal open={showModal} onCancel={() => setShowModal(false)} width={'90vw'} zIndex={1000} footer={null} closable>
        <Plate
          selectedPlateLine={selectedPlateLine}
          handleSelectPlateLine={handleSelectPlateLine}
          plateLines={plateLines}
          handleClose={handleChangeShowModal}
        />
      </SModal>
    </>
  );
};

export default PlateModal;
